import { render, staticRenderFns } from "./ProjectSelect.vue?vue&type=template&id=06d0be38&scoped=true&"
import script from "./ProjectSelect.vue?vue&type=script&lang=js&"
export * from "./ProjectSelect.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./ProjectSelect.vue?vue&type=style&index=1&id=06d0be38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d0be38",
  null
  
)

component.options.__file = "ProjectSelect.vue"
export default component.exports